import tw from "twin.macro";

export const ChainTitle = tw.span`
  hidden md:block
`;
